// extracted by mini-css-extract-plugin
module.exports = {"feedbackTextArea":"FeedbackTextArea_feedbackTextArea__7pG_1","block":"FeedbackTextArea_block__1a3GR","title":"FeedbackTextArea_title__1RMBq"};